import { CurrencyIdentifierFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { useSwapCurrenciesFragment } from "../../../hooks/useSwapCurrencies"

export const SwapDetailsCollapsedItemFragment = graphql(
  `
    fragment SwapDetailsCollapsedItem on SwapRouteResult {
      ...useSwapCurrencies
      ... on SwapRoute {
        fromAsset {
          ...CurrencyIdentifier
        }
        toAsset {
          ...CurrencyIdentifier
        }
        costs {
          costType
          cost {
            usd
          }
        }
        pricePerFromAsset {
          usd
          token {
            unit
          }
        }
        pricePerToAsset {
          usd
          token {
            unit
          }
        }
      }
    }
  `,
  [CurrencyIdentifierFragment, useSwapCurrenciesFragment],
)
